const state = {
  // 当前桌面
  desktop: "",
  // 桌面配置
  desktopSetting: false,
  // 用户中心
  userCenter: false,
  // 页面滚动高度
  scrollTop: 0,
  // 滚动至底部的次数
  scrollToBottom: 0
};

const mutations = {
  // 当前桌面
  setDesktop: (state, desktop) => {
    state.desktop = desktop;
    window.localStorage.Desktop = desktop;
  },

  // 打开桌面配置
  openDesktopSetting: (state, payload) => {
    state.desktopSetting = payload;
  },
  // 打开个人中心
  openUserCenter: (state, payload) => {
    state.userCenter = payload;
  },
  // 滚动高度
  setScrollTop: (state, payload) => {
    state.scrollTop = payload;
  },
  // 滚动至底部
  scrollToBottom: state => {
    state.scrollToBottom++;
  }
};

const actions = {};

export default {
  state,
  mutations,
  actions
};
